import SignInButton from './SignInButton';

export default function SignIn() {
    return (
        <div className="flex w-full h-full justify-center items-center mt-[20vh]">
            <div className="px-4 md:px-12  pt-2 pb-6 flex flex-col items-center justify-center bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
                <div className="flex items-center mb-12">
                    <img
                        src="/android-chrome-512x512.png"
                        className="mr-3 h-6 sm:h-9"
                        alt="NREP Map Notes logo"
                    />
                    <span className="self-center text-xl font-semibold whitespace-nowrap dark:text-white">
                        Map Notes{' '}
                        <span className="text-sm font-light text-gray-500">
                            by NREP AI Labs
                        </span>
                    </span>
                </div>

                <svg
                    className="w-20 h-20"
                    viewBox="0 0 66 85"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0)" fill="#263746">
                        <path d="M64.98 8.147c.558.366.646.461.646 1.297v43.694c0 .835-.183 1.018-.837 1.575l-7.985 7.312c-.279.278-.558.556-.925.556-.28 0-.559-.183-.838-.366L30.918 45.27 12.635 61.19c-.374.374-.742.653-1.204.653-.463 0-.838-.374-1.117-.557l-9.652-6.85c-.558-.374-.646-.462-.646-1.297V9.348c0-.74.095-.923.741-1.48L8.83.557C9.11.278 9.381 0 9.756 0c.279 0 .558.183.837.374l24.13 16.938 18.284-15.92c.374-.374.742-.652 1.204-.652.463 0 .838.374 1.117.557l9.652 6.85zM1.962 10.924v42.03l8.536 6.016V30.55c0-.556.463-1.018.925-1.018.463 0 .742.184 1.3.557l43.068 30.273 7.242-6.667-61.07-42.772zM63.68 51.657V9.627l-8.536-6.015V32.03c0 .556-.463 1.018-.925 1.018-.463 0-.742-.183-1.3-.557L9.85 2.22 2.616 8.887l61.064 42.77zm-51.236 7.128l16.8-14.623-16.8-11.854v26.477zm40.754-54.99l-16.8 14.63 16.8 11.847V3.795zM3.386 74.655v9.832c0 .352-.154.506-.485.506H.486c-.33 0-.485-.154-.485-.506V70.04c0-.352.154-.506.485-.506h2.218c.33 0 .573.11.8.396l8.243 9.634V70.04c0-.352.154-.506.484-.506h2.417c.33 0 .485.154.485.506v14.454c0 .352-.154.506-.485.506h-1.969c-.33 0-.573-.11-.8-.396l-8.492-9.949zm22.735 5.414h-3.497v4.418c0 .352-.154.506-.484.506h-2.417c-.33 0-.485-.154-.485-.506V70.04c0-.352.154-.506.485-.506h7.22c3.615 0 6.075 1.942 6.075 5.107 0 2.871-1.594 4.22-3.342 4.842l3.548 5.107c.176.285.11.417-.22.417h-3.056a.816.816 0 01-.75-.417l-3.077-4.52zm.867-7.553h-4.364v4.637h4.43c1.66 0 2.593-.974 2.593-2.344 0-1.436-1.021-2.293-2.66-2.293zm9.453-2.476c0-.352.155-.506.485-.506h11.188c.33 0 .484.154.484.506v1.963c0 .352-.154.506-.484.506h-8.279v3.201h7.22c.331 0 .486.154.486.506v1.963c0 .352-.155.506-.485.506h-7.22v3.311h8.77c.33 0 .484.154.484.506v1.963c0 .352-.154.506-.484.506H36.934c-.331 0-.485-.154-.485-.506V70.04h-.008zm19.613 10.337v4.11c0 .352-.154.506-.485.506h-2.416c-.331 0-.485-.154-.485-.506V70.04c0-.352.154-.506.485-.506h6.912c3.724 0 5.935 2.205 5.935 5.348 0 3.649-2.77 5.502-6.273 5.502h-3.673v-.007zm3.85-7.861h-3.857v4.887h3.922c1.682 0 2.703-1.085 2.703-2.455 0-1.53-1.08-2.432-2.769-2.432z" />
                    </g>
                    <defs>
                        <clipPath id="clip0">
                            <path fill="#fff" d="M0 0h66v85H0z" />
                        </clipPath>
                    </defs>
                </svg>

                <div className="mt-8 flex flex-col items-center">
                    <h3 className="mb-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Welcome
                    </h3>
                    <p className="mb-8  font-normal text-gray-500 dark:text-gray-400">
                        Sign in with your NREP Microsoft account to get started.
                    </p>
                    <SignInButton />
                </div>
            </div>
        </div>
    );
}
